import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminSettings() {
  const [tenant, setTenant] = useState(null);
  const [form, setForm] = useState({ school_name:'', contact_email:'', contact_phone:'', address:'', timezone:'Europe/London', max_students:100, homework_enabled:true, ai_tutor_enabled:true });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/api/admin/dashboard').then(r=>{
      const t = r.data?.tenant;
      setTenant(t);
      if(t) setForm(f=>({...f, school_name:t.school_name||'', contact_email:t.contact_email||'', contact_phone:t.contact_phone||'', address:t.address||'', max_students:t.max_students||100, homework_enabled:t.homework_enabled!==false, ai_tutor_enabled:t.ai_tutor_enabled!==false, timezone:t.timezone||'Europe/London'}));
    }).catch(()=>{});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/api/admin/settings', form);
      toast.success('Settings saved');
    } catch { toast.error('Failed to save'); }
    setSaving(false);
  };

  const C = { navy:'#0D1B2A', teal:'#00B4D8', grey:'#6B7280', border:'#E5E7EB' };
  const inp = (field) => ({ value:form[field]||'', onChange:e=>setForm(f=>({...f,[field]:e.target.value})), style:{width:'100%',padding:'10px 12px',border:`1.5px solid ${C.border}`,borderRadius:8,fontSize:14,boxSizing:'border-box'} });

  return (
    <Layout role="tenant_admin" tenantColor={tenant?.primary_colour} tenantName={tenant?.school_name}>
      <div style={{marginBottom:24}}>
        <h2 style={{margin:'0 0 4px',fontSize:22,fontWeight:700,color:C.navy}}>School Settings</h2>
        <p style={{margin:0,color:C.grey,fontSize:14}}>Manage your school configuration and preferences</p>
      </div>
      <div style={{background:'#fff',borderRadius:12,padding:28,boxShadow:'0 1px 4px rgba(0,0,0,0.08)',maxWidth:640}}>
        <div style={{fontWeight:700,fontSize:15,color:C.navy,marginBottom:18}}>Basic Information</div>
        {[['School Name','school_name'],['Contact Email','contact_email'],['Contact Phone','contact_phone'],['Address','address']].map(([label,field])=>(
          <div key={field} style={{marginBottom:16}}>
            <label style={{display:'block',fontWeight:600,fontSize:13,color:C.navy,marginBottom:6}}>{label}</label>
            <input {...inp(field)} />
          </div>
        ))}
        <div style={{marginBottom:16}}>
          <label style={{display:'block',fontWeight:600,fontSize:13,color:C.navy,marginBottom:6}}>Timezone</label>
          <select value={form.timezone} onChange={e=>setForm(f=>({...f,timezone:e.target.value}))} style={{width:'100%',padding:'10px 12px',border:`1.5px solid ${C.border}`,borderRadius:8,fontSize:14}}>
            {['Europe/London','Asia/Tashkent','Asia/Dubai','Europe/Paris','America/New_York'].map(tz=><option key={tz}>{tz}</option>)}
          </select>
        </div>
        <div style={{borderTop:`1px solid ${C.border}`,paddingTop:18,marginTop:18}}>
          <div style={{fontWeight:700,fontSize:15,color:C.navy,marginBottom:14}}>Features</div>
          {[['AI Tutor enabled','ai_tutor_enabled'],['Homework generation','homework_enabled']].map(([label,field])=>(
            <div key={field} style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12,padding:'12px 16px',background:'#F9FAFB',borderRadius:8}}>
              <span style={{fontSize:14,color:C.navy}}>{label}</span>
              <button onClick={()=>setForm(f=>({...f,[field]:!f[field]}))} style={{width:44,height:24,borderRadius:12,border:'none',cursor:'pointer',background:form[field]?C.teal:'#D1D5DB',transition:'background 0.2s',position:'relative'}}>
                <div style={{position:'absolute',width:18,height:18,borderRadius:'50%',background:'#fff',top:3,left:form[field]?23:3,transition:'left 0.2s'}}/>
              </button>
            </div>
          ))}
        </div>
        <button onClick={save} disabled={saving} style={{width:'100%',padding:'12px 0',background:C.teal,color:'#fff',border:'none',borderRadius:10,fontWeight:700,fontSize:15,cursor:'pointer',marginTop:16}}>
          {saving ? 'Saving…' : 'Save Settings'}
        </button>
      </div>
    </Layout>
  );
}
